<div class="vh-100 vw-100 d-flex align-items-center justify-content-center bg-black">
  <div class="container-fluid h-100">
    <div class="row h-100">
      <!-- Left Illustration Section -->
      <div class="login-graphic col-md-6 d-none d-md-flex align-items-center justify-content-center p-0">
        <!-- <img
        src="assets/img/images/login-graphic.png"
        alt="Illustration"
        class="img-fluid"
        style="max-height: 70vh"
        /> -->
        <img src="assets/img/theme/dark-login-graphic.png" alt="Illustration" class="img-fluid"
          style="max-height: 70vh" />
        </div>

        <!-- Right Login Form Section -->
        <div
          class="card col-md-6 d-flex align-items-center justify-content-center bg-white position-relative reg-flow-bg">
          <div class="w-100" style="max-width: 400px">
            <div class="text-center mb-4">
              <!-- <img
              src="assets/img/images/illum-tezzeract-logo.png"
              alt="Illum Logo"
              /> -->
              <img src="assets/img/theme/dark-theme-white-logo.png" alt="Illum Logo" />
            </div>
            <h2 class="fw-bold text-center mb-4 signIn-title">
              {{ isForgotPassword ? "Forgot Password" : "Welcome to Illum" }}
            </h2>

            <!-- Login Form -->
            @if (showLogin) {
              <form #LoginForm="ngForm" autocomplete="off" novalidate>
                @if (isError) {
                  <div class="alert alert-danger text-center py-2">
                    {{ _message }}
                  </div>
                }
                @if (isSuccess) {
                  <div class="alert alert-success text-center py-2">
                    {{ _message }}
                  </div>
                }
                <!-- Email Input -->
                <div class="mb-3 input-container">
                  <input id="username" name="username" type="text" class="form-control form-control-lg" placeholder=""
                    [(ngModel)]="_login.UserName" #UserName="ngModel" required autocomplete="username"
                    style="background: #f5f5f5; border: none; font-size: 1.1rem" (keydown.space)="$event.preventDefault()"
                    autofocus />
                    <label for="username" class="form-label">Username / Email</label>
                    @if (UserName.errors?.['required'] && UserName.touched && _displayError) {
                      <span
                      class="help-block text-danger">{{ requiredField.REQUIRED_FIELD }}</span>
                    }
                  </div>
                  <!-- Password Input -->
                  <div class="mb-3 input-container position-relative">
                    <input id="password" name="password" [type]="passwordVisible ? 'text' : 'password'"
                      class="form-control form-control-lg" placeholder="" [(ngModel)]="_login.Password" #password="ngModel"
                      required autocomplete="current-password" style="background: #f5f5f5; border: none; font-size: 1.1rem" />
                      <label for="password" class="form-label">Password</label>
                      <!-- Eye Icon -->
                      <span class="position-absolute top-50 end-0 translate-middle-y me-3" style="cursor: pointer"
                        (click)="togglePasswordVisibility()">
                        <i class="fa" [ngClass]="passwordVisible ? 'fa-eye-slash' : 'fa-eye'"></i>
                      </span>
                      @if (password.errors?.['required'] && password.touched && _displayError) {
                        <span
                          class="help-block text-danger">
                          {{ requiredField.PASSWORD_FIELD }}
                        </span>
                      }
                    </div>
                    <!-- Stay Signed In Checkbox: always visible and centered -->
                    <div class="d-flex justify-content-between align-items-center mb-3">
                      <div class="form-check">
                        <input type="checkbox" class="form-check-input" id="staySignedIn" [(ngModel)]="_login.staySignedIn"
                          name="staySignedIn" />
                          <label class="form-check-label" for="staySignedIn" style="font-size: 1rem">Stay Signed In</label>
                        </div>
                        <div>
                          <button type="button" class="btn btn-link p-0 text-decoration-none" (click)="ShowForgotPassword()"
                            style="font-size: 0.9rem">
                            Forgot Password?
                          </button>
                        </div>
                      </div>
                      <!-- Log In Button -->
                      <div class="d-flex justify-content-center mb-3">
                        <button type="button" class="btn btn-primary btn-sign-in" (click)="Login(LoginForm)"
                          [disabled]="!LoginForm.form.valid">
                          Log In <i class="fa-solid fa-chevron-right"></i>
                        </button>
                      </div>
                    </form>
                  }
                  <!-- Forgot Password Form -->
                  @if (_showForgotPassword) {
                    <div>
                      @if (isError) {
                        <div class="alert alert-danger text-center py-2">
                          {{ _forgotMessage }}
                        </div>
                      }
                      <form #ForgotForm="ngForm" autocomplete="off" novalidate>
                        <div class="form-group mb-3 input-container">
                          <input id="EmailAddress" name="EmailAddress" type="email" maxlength="64" class="form-control"
                            [(ngModel)]="_login.EmailID" #EmailAddress="ngModel" required
                            pattern="[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,3}$" (keydown.space)="$event.preventDefault()"
                            (keyup.space)="$event.preventDefault()"
                            aria-describedby="EmailAddressRequired-Error EmailAddressInvalid-Error" />
                            <label for="EmailAddress">Email</label>
                            @if (EmailAddress.errors?.['required'] && EmailAddress.touched) {
                              <span id="EmailAddress-Required-Error" aria-live="polite"
                                class="help-block text-danger">{{
                              requiredField.EMAIL_REQUIRED }}</span>
                            }
                            @if (EmailAddress.errors?.['pattern'] && EmailAddress.touched) {
                              <span id="EmailAddress-Max-Chars-Error" aria-live="polite"
                                class="help-block text-danger">{{
                              requiredField.EMAIL_FORMAT }}</span>
                            }
                          </div>
                          <div class="form-actions progressfade">
                            <button type="button" class="btn btn-primary btn-sign-in me-2" (click)="ForgotPassword()"
                              [disabled]="ForgotForm.invalid">
                              Forgot password <i class="fa-solid fa-chevron-right"></i>
                            </button>
                            <button type="button" class="btn btn-outline-secondary" (click)="cancelForgotPassword()">
                              Cancel
                            </button>
                          </div>
                        </form>
                      </div>
                    }

                    @if (_showResetPassword) {
                      <div>
                        @if (isError) {
                          <div class="alert alert-danger text-center py-2">
                            {{ _resetError }}
                          </div>
                        }
                        <form #ResetForm="ngForm" autocomplete="off" novalidate>
                          <div class="form-group mb-3 input-container">
                            <input type="text" name="verificationCode" id="verificationCode" class="form-control form-control-lg"
                              [(ngModel)]="verificationCode" #verificationCodeField="ngModel"
                              style="background: #f5f5f5; border: none; font-size: 1.1rem" required />
                              <label for="verificationCode" class="form-label">Enter verification code</label>
                              @if (
                                verificationCodeField.invalid &&
                                verificationCodeField.touched
                                ) {
                                <span class="help-block text-danger">
                                  Verification Code is required
                                </span>
                              }
                            </div>
                            <div class="form-group mb-3 input-container">
                              <input type="password" name="newPassword" id="newPassword" class="form-control form-control-lg"
                                [(ngModel)]="newPassword" #newPasswordField="ngModel"
                                style="background: #f5f5f5; border: none; font-size: 1.1rem" required />
                                <label for="newPassword" class="form-label">Enter new password</label>
                                @if (newPasswordField.invalid && newPasswordField.touched) {
                                  <span class="help-block text-danger">
                                    Password is required
                                  </span>
                                }
                              </div>
                              <div class="form-group mb-3 input-container">
                                <input type="password" name="verifyNewPassword" id="verifyNewPassword"
                                  class="form-control form-control-lg" [(ngModel)]="verifyNewPassword" #verifyNewPasswordField="ngModel"
                                  required style="background: #f5f5f5; border: none; font-size: 1.1rem" />
                                  <label for="verifyNewPassword" class="form-label">Verify new password</label>
                                  @if (
                                    verifyNewPasswordField.invalid &&
                                    verifyNewPasswordField.touched
                                    ) {
                                    <span class="help-block text-danger">
                                      Verify new password is required
                                    </span>
                                  }
                                </div>
                                <div class="form-actions progressfade">
                                  <button type="button" class="btn btn-primary btn-sign-in me-2" (click)="resetPassword()"
                                    [disabled]="ResetForm.invalid">
                                    Reset password <i class="fa-solid fa-chevron-right"></i>
                                  </button>
                                  <button type="button" class="btn btn-outline-secondary" (click)="cancelResetPassword()">
                                    Cancel
                                  </button>
                                </div>
                              </form>
                            </div>
                          }

                          <!-- Footer -->
                          <div
                            class="position-absolute bottom-0 start-50 translate-middle-x mb-3 copyright-text small text-center w-100">
                            Copyright © 2026 Illum AI. All Rights Reserved
                          </div>

                          <!-- <img
                          src="assets/img/illum-logo-faded.svg"
                          alt=""
                          class="position-absolute top-0 end-0"
            style="
              width: 250px;
              opacity: 0.05;
              pointer-events: none;
              z-index: 0;
            "
                          /> -->
                        </div>
                      </div>
                    </div>
                  </div>
                </div>